import { RouteObject } from "react-router-dom";
import { RulesList } from "@/pages/admin/rules/RulesList";
import { RuleCreate } from "@/pages/admin/rules/RuleCreate";
import { RuleDetail } from "@/pages/admin/rules/RuleDetail";
import { RuleEdit } from "@/pages/admin/rules/RuleEdit";

export const rulesRoutes: RouteObject[] = [
  // Rules
  {
    id: "rules-list",
    index: true,
    element: <RulesList />,
  },
  {
    id: "rules-create",
    path: "create",
    element: <RuleCreate />,
  },
  {
    id: "rules-detail",
    path: ":id",
    element: <RuleDetail />,
  },
  {
    id: "rules-edit",
    path: ":id/edit",
    element: <RuleEdit />,
  },
];
